import React from 'react';
import PropTypes from 'prop-types';
import Table from 'relements/build/esm/ui/table';

import styles from './ThresholdTable.scss';

// columns for table component
const columns = [
  {
    title: 'Parameter',
    sortKey: 'title',
    width: '180px',
  },
  {
    title: 'Priority',
    sortKey: 'priority',
    width: '80px',
  },
  {
    title: 'Threshold',
    sortKey: 'threshold',
    width: '100px',
  },
  {
    title: 'Classifier Flag',
    sortKey: 'cFlag',
    width: '120px',
  },
  {
    title: 'Classifier',
    sortKey: 'classifierSort',
    width: '70vw - 480px',
  },
];

export default class ThresholdTable extends React.Component {
  static propTypes = {
    botData: PropTypes.shape({
      active: PropTypes.bool,
      test_business: PropTypes.string,
      description: PropTypes.string,
      client: PropTypes.string,
      id: PropTypes.string,
      title: PropTypes.string,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (!this.props.thresholds) return null;

    const rowData = this._generateData();
    return (
      <div className={styles.container}>
        <div className={styles.containerTitle}>
          Thresholds (Machine Learning Related Information){' '}
        </div>
        <Table
          sortable
          columns={columns}
          rows={rowData}
          className={styles.small_text}
        />
      </div>
    );
  }

  // renders appropriate priority
  renderPriority = priority => (priority !== 5 ? priority : 'NA');

  // renders Classifier JSON
  renderJSONClassifier = item => {
    if (item.flag !== 'ON') return item.classifier;
    return (
      <div>
        <button
          className={styles.jsonButton}
          size="small"
          onClick={() => this._toggleJSONVisibility()}
        >
          {this.state.showJSON ? 'Hide JSON' : 'Show JSON'}
        </button>
        <p className={styles.jsonFont}>
          {this.state.showJSON ? item.classifier : null}
        </p>
      </div>
    );
  };

  // Controls Hide/Show JSON
  _toggleJSONVisibility() {
    this.setState({ showJSON: !this.state.showJSON });
  }

  // generates column data for a table
  _generateColumn = content => ({
    content,
  });

  // generates relevant data for the table component
  _generateData() {
    return (this.props.thresholds || []).map(item => {
      const row = {
        columns: [],
        disabled: false,
      };
      if (item.status) {
        row.columns.push(this._generateColumn(item.name));
        row.columns.push(
          this._generateColumn(this.renderPriority(item.priority))
        );
        row.columns.push(this._generateColumn(item.threshold));
        row.columns.push(this._generateColumn(item.flag));
        row.columns.push(this._generateColumn(this.renderJSONClassifier(item)));
      } else {
        row.disabled = true;
        row.columns.push(this._generateColumn(`${item.name} OFF`));
        row.columns.push(this._generateColumn(''));
        row.columns.push(this._generateColumn(''));
        row.columns.push(this._generateColumn(''));
        row.columns.push(this._generateColumn(''));
      }

      return row;
    });
  }
}
